/**
 * @generated SignedSource<<b51a6da91b434bfa5caec50dbcc16944>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionCountdownLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionCountdown_item">;
  readonly " $fragmentType": "PdpSharedAuctionCountdownLazy_item";
};
export type PdpSharedAuctionCountdownLazy_item$key = {
  readonly " $data"?: PdpSharedAuctionCountdownLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionCountdownLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionCountdownLazy_item",
  "selections": [
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedAuctionCountdown_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "622908eec34bf8d33c0194bacaa7af53";

export default node;
